export default 'M6 4a2 2 0 1 1-4 0 2 2 0 0 1 4 0m3-1.5h14v3H9zm14 11H9v-3h14zm0 8H9v-3h14zM2 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0m4 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0';